import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import styled from 'styled-components';

const StyledImage = styled(Image)`
  margin: 0 auto;
`;

const StyledCloseButton = styled(Box)`
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
`;

const StyledBox = styled(Box)`
  .fade-in {
    opacity: 0.1;
    transition: opacity 0.5s ease-in-out;
  }

  .fade-in.active {
    opacity: 1;
  }
`;

const StyledLink = styled(Link)`
  width: fit-content;
`;

function PartnerModal({ closeModal, item }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    // Trigger animation after a short delay to ensure proper rendering
    setTimeout(() => setActive(true), 10);
  }, []);

  const handleClose = () => {
    setActive(false);
    // Wait for the animation to complete before closing the modal
    setTimeout(closeModal, 100); // Adjust the timeout to match the transition duration
  };

  const handleOverlayClick = e => {
    // Check if the target element is the overlay (background)
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <StyledBox
      position="fixed"
      top="0"
      left="0"
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      backgroundColor="rgba(0, 0, 0, 0.7)"
      zIndex="999"
      overflow="scroll"
      key={item.id}
      onClick={handleOverlayClick}
    >
      <StyledBox
        backgroundColor="white.default"
        paddingTop="30px"
        paddingBottom="30px"
        paddingRight="43px"
        paddingLeft="29px"
        borderRadius="12px"
        boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)"
        position="relative"
        width={{ xs: '100%', md: '930px' }}
        display="flex"
        flexDirection="column"
        alignItems={{ xs: 'left', md: 'center' }}
        margin={{ xs: '8x', md: '0' }}
        className={`fade-in ${active ? 'active' : ''}`}
      >
        <StyledCloseButton onClick={closeModal}>
          <Image
            alt="Cerrar"
            src="benefits/close-big.svg"
            webp
            width="auto"
            importance="high"
            loading="lazy"
          />
        </StyledCloseButton>

        <StyledImage
          alt={item.image.alt}
          src={item.image.url}
          width={{ xs: '151px' }}
          height={{ xs: '134px' }}
          loading="lazy"
          objectFit="contain"
          webp
        />

        <Typography
          marginTop="30px"
          variant="heading4"
          strong
          textAlign={{ xs: 'left', md: 'center' }}
          maxWidth={{ xs: '100%', md: '459px' }}
        >
          {item.title}
        </Typography>

        <Typography
          variant="paragraph1"
          marginTop={{ xs: '20px', md: '35px' }}
          marginBottom={{ xs: '20px', md: '35px' }}
          maxWidth={{ xs: '100%', md: '459px' }}
          whiteSpace="pre-line"
        >
          {item.description}
        </Typography>

        {item.moreLink && (
          <StyledLink
            href={item.moreLink}
            variant="action"
          >
            Conoce más
          </StyledLink>
        )}

      </StyledBox>
    </StyledBox>
  );
}

PartnerModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  item: PropTypes.shape({
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    image: PropTypes.shape({
      alt: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    moreLink: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default PartnerModal;
